//import { SAVE_PERSONAL_DETAILS } from "./../types";
import TokenService from "../../services/Token.Service";
import EncrDecrService from "../../services/EncrDecrService.Service";
import { SetTokenValues } from "../../shared/SharedUtility";
import GlobalService from "../../services/GlobalService";

export const funcSetAccessToken = (passPhrase,userDetail,oauthPayload,partner) => async (dispatch) => {
  if(partner){
    GlobalService.setOAuthToken(oauthPayload);
  }
  else{
  try {
    await TokenService.getAuthToken(passPhrase).then(
      (res) => {
        if (res.data) {
          const decryptToken = EncrDecrService.getWithPassPhrase(res.data, passPhrase);
          const tokenValues = JSON.parse(decryptToken);
          const oauthPayload = {
            accessToken: tokenValues?.accessToken,
            cookie: tokenValues?.sbicUserFgp,
            clientIPAddress: tokenValues?.clientIPAddress,
            visitorId: tokenValues?.visitorID
          }
          GlobalService.setOAuthToken(oauthPayload);
          SetTokenValues(oauthPayload);
        }

      }
    );
  }
  catch (err) {
    //dispatch(setError("Error fetching card details..."));
  }
}
};
